import { markAgentQuestionAnswered } from '@/features/chat/agentQuestion/markAgentQuestionAnswered.js'

export function markOpenAgentQuestionAnsweredInSnapshot(messages, tid, selectedAnswer) {
  const answer = String(selectedAnswer ?? '').trim()
  if (!tid || !messages?.length || !answer) return messages ?? []
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const msg = messages[i]
    if (msg?.role !== 'assistant' || msg.agentQuestion?.status !== 'open') continue
    return markAgentQuestionAnswered(
      { [tid]: messages },
      { tid, assistantMessageId: msg.id, selectedAnswer: answer },
    )[tid]
  }
  return messages
}
